module.exports = __webpack_public_path__ + "static/media/IMG-20191012-WA0001.d62f2c5a.jpg";